import React from "react";
import { Link } from "react-router-dom";
import colors, { orange } from "tailwindcss/colors";

export default function Login() {
  return (
    <>
    <div className="container mx-auto px-4 h-full">
      <div className="flex content-center items-center justify-center h-full">
        <div className="w-full lg:w-4/12 px-4 mb-4"> {/* Burada mb-4 ekledim */}
          <div className="relative flex flex-col min-w-0 break-words w-full shadow-lg rounded-lg bg-white border-0">
            <div className="text-lg font-medium text-center py-4">
              Bucked Games içeriklerini görmek için Metodbox
              Öğrenme araçları menüsünden Bucked Games üzerinden giriş yapın.
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div className="container mx-auto px-4 h-full">
      <div className="flex content-center items-center justify-center h-full">
        <div className="w-full lg:w-4/12 px-4">
          <div className="relative flex flex-col min-w-0 break-words w-full shadow-lg rounded-lg bg-black border-0">
            <a
              href="https://yeni.metodbox.com/login"
              className="bg-ff6900 hover:bg-fc7d02 text-white font-semibold px-4 py-2 rounded flex justify-center items-center" 
              target="_blank"
              rel="noopener noreferrer"
            >
              Metodbox'a Giriş Yap
            </a>
          </div>
        </div>
      </div>
    </div>
  </>
  
    //   <>

    //   <div className="container mx-auto px-4 h-full">
    //     <div className="flex content-center items-center justify-center h-full">
    //       <div className="w-full lg:w-4/12 px-4">
    //         <div className="relative flex flex-col min-w-0 break-words w-full shadow-lg rounded-lg bg-orange-200 border-0">
    //           <div className="text-lg font-medium text-center py-4">
    //             Bucked Games içeriklerini görmek için{" "}
    //             <a
    //               href="https://yeni.metodbox.com/login"
    //               className="text-blue-500 underline"
    //               target="_blank"
    //               rel="noopener noreferrer"
    //             >
    //               yeni.metodbox.com
    //             </a>{" "}
    //             Öğrenme araçları menüsünden Bucked Games üzerinden giriş yapın.
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </>

  );
}
